import React from 'react';
import PropTypes from 'prop-types'

import * as S from './styled';



const Toggle = ({setIsCelsius}) => {
  const fahrenheitHandler = () => {
    setIsCelsius(false);
    localStorage.metric = "°F"
  }
  const CelsiusHandler = () => {
    setIsCelsius(true);
    localStorage.metric = "°С"
  }
  return (
    <S.ToggleGroup>
      <S.ToggleItem onClick={fahrenheitHandler}>
        <S.Radio id="fid-1" type="radio" name="radio" value="°F" defaultChecked={localStorage.metric === "°F"} />
        <S.Label htmlFor="fid-1">°F</S.Label>
      </S.ToggleItem>
      <S.ToggleItem onClick={CelsiusHandler}>
        <S.Radio id="fid-2" type="radio" name="radio" value="°С" defaultChecked={localStorage.metric === "°С"} />
        <S.Label htmlFor="fid-2">°С</S.Label>
      </S.ToggleItem>
    </S.ToggleGroup>
  );
};

Toggle.propTypes = {
  setIsCelsius: PropTypes.func.isRequired,
};

export default Toggle;
